export default __webpack_public_path__ + "static/media/1612.9a09e465.png";